module.exports = __webpack_public_path__ + "img/symbol_5.839734c8.png";